export enum OrderTicketPreference {
  Quick = 'Quick',
  Full = 'Full'
}

export enum TradeType {
  SHARE = 'SHARE',
  MFUND = 'MFUND'
}

export const tradeTypeToPath: Record<TradeType, string> = {
  [TradeType.SHARE]: `Manage`,
  [TradeType.MFUND]: `mFund`
};

export const ORDER_TICKET_WINDOW_HEIGHT = 750;
export const ORDER_TICKET_WINDOW_WIDTH = 587;

export enum Direction {
  Buy = 'Buy',
  Sell = 'Sell'
}
